module.exports = __webpack_public_path__ + "static/index/img/baikal-110.eb9abe0b.jpg";